import React from 'react';
import classNames from 'classnames';
import { MapboxView } from '@bringg/types';
import { Button } from 'components';

interface Translations {
	streets: string;
	satellite: string;
}

interface MapboxViewsProps {
	mapViews: MapboxView[];
	currentMapboxView: MapboxView;
	translations: Translations;
	changeMapView: (mapboxView: MapboxView) => void;
	className?: string;
}

export const MapboxViews = (props: MapboxViewsProps) => {
	const { mapViews, currentMapboxView, translations, changeMapView, className } = props;
	return (
		<div className={classNames('mapbox-views-container', className)}>
			{mapViews.map(mapView => {
				const isActive = currentMapboxView === mapView;
				return (
					<Button
						key={mapView}
						className={classNames('map-view-btn', { 'map-view-btn-active': isActive })}
						onClick={() => changeMapView(mapView)}
					>
						{translations[mapView]}
					</Button>
				);
			})}
		</div>
	);
};
